import { inject, Injectable } from '@angular/core';
import { SquareLocationProductionEndpoints } from 'app/core/enums/endpoints/gateway.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import { SquareLocationProductionPayload } from '../../types';

@Injectable({
    providedIn: 'root',
})
export class SquareLocationProductionService {
    private _endpoint = SquareLocationProductionEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ------------------------------------------------------------------
    // @ CRUD methods
    // ------------------------------------------------------------------

    getAll(): Observable<any> {
        return this._apiService.get(this._endpoint.getAll);
    }

    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    create(data: SquareLocationProductionPayload): Observable<any> {
        return this._apiService.post(this._endpoint.create, data);
    }

    update(data: SquareLocationProductionPayload, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.update, data);
    }

    delete(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.delete, id);
    }
}
